import { render } from "./FarmList.vue?vue&type=template&id=0e8ae0db"
import script from "./FarmList.vue?vue&type=script&lang=js"
export * from "./FarmList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/area/FarmList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e8ae0db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e8ae0db', __exports__)) {
    api.reload('0e8ae0db', __exports__)
  }
  
  module.hot.accept("./FarmList.vue?vue&type=template&id=0e8ae0db", () => {
    api.rerender('0e8ae0db', render)
  })

}


export default __exports__